import type { WebsiteHeaderPhotoSchema_PhotoMarqueePageWidth } from '@shared/types/WebsiteHeaderSettings.types';

export const PHOTO_MARQUEE_PAGE_WIDTH_DEFAULT: WebsiteHeaderPhotoSchema_PhotoMarqueePageWidth = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoMarqueePageWidth-v1_0_0.json',
  presentationLayout: 'photoMarqueePageWidth',
  photos: [],
};
